window.openVideoModal = function (youtubeUrl) {
  // remove modal antigo se existir
  const oldModal = document.getElementById("videoModal");
  if (oldModal) {
    oldModal.remove();
  }

  const isMobile = window.matchMedia("(max-width: 767.98px)").matches;

  // cria o HTML do modal
  const modalHTML = `
        <div class="modal fade" id="videoModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl modal-fullscreen-md-down">
                <div class="modal-content bg-black">
                    <div class="modal-header border-0">
                        <button type="button" class="btn-close btn-close-white ms-auto" data-bs-dismiss="modal"></button>
                    </div>

                    <div class="modal-body p-0">
                        <div class="ratio ratio-16x9">
                            <iframe
                                src="${youtubeUrl}?autoplay=1${
                                  isMobile ? "&playsinline=1" : ""
                                }"
                                frameborder="0"
                                allow="autoplay; encrypted-media; picture-in-picture"
                                allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;

  // injeta no body
  document.body.insertAdjacentHTML("beforeend", modalHTML);

  const modalEl = document.getElementById("videoModal");
  const modal = new bootstrap.Modal(modalEl);

  // remove do DOM ao fechar
  modalEl.addEventListener("hidden.bs.modal", () => {
    modalEl.remove();
  });

  modal.show();
};
